import * as React from "react";
const SvgFiBrandsSap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="m8.789 10.709.736 2.369a2.2 2.2 0 0 1-.742.126c-.275 0-.534-.048-.757-.133l.749-2.362zM15.63 10.882c0 .734-.554.965-1.248.965h-.52V9.942h.52c.694 0 1.248.23 1.248.94"
      clipRule="evenodd"
    />
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M0 6.064v11.873h12.129L24 6.064zm14.625 7.407h-.764l-.009 2.094-3.588-.003-.25-.907c-.37.121-.788.189-1.232.189-.455 0-.884-.071-1.262-.2l-.359.919-2 .006.09-.462q-.041.038-.087.074c-.534.43-1.207.629-2.036.644l-.214.002a5.1 5.1 0 0 1-2.58-.675l.73-1.448c.791.467 1.287.572 1.956.558.347-.007.597-.07.761-.239a.55.55 0 0 0 .156-.369c.007-.376-.529-.553-1.185-.756-.531-.165-1.135-.389-1.607-.734-.558-.411-.824-.925-.811-1.65a2 2 0 0 1 .565-1.378c.521-.538 1.359-.864 2.365-.864h.005c.863.001 1.915.246 2.676.633l-.821 1.43c-.834-.403-1.254-.442-1.729-.467-.708-.037-1.064.215-1.07.488-.007.332.669.633 1.306.838.964.306 2.189.715 2.377 1.9L7.77 8.436h2.047l2.064 5.577-.008-5.575h2.37c2.258 0 3.318.764 3.319 2.518-.001 1.575-1.091 2.515-2.937 2.515"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsSap;
